module.exports.RADIUS = 6378137;
module.exports.FLATTENING = 1/298.257223563;
module.exports.POLAR_RADIUS = 6356752.3142;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/wgs84/index.js
// module id = ../../../../wgs84/index.js
// module chunks = vendor